document.addEventListener("DOMContentLoaded", () => {
	const featuredProductCategoriesSwipers = document.querySelectorAll(".featured-product-categories__category-swiper");

	if (featuredProductCategoriesSwipers) {
		featuredProductCategoriesSwipers.forEach((swiperContainer) => {
			const swiper = new Swiper(swiperContainer, {
				// Optional parameters
				keyboard: true,
				slidesPerView: swiperContainer.dataset.slidesPerViewMobile,
				spaceBetween: 30,
				breakpoints: {
					768: {
						slidesPerView: swiperContainer.dataset.slidesPerViewTablet,
					},
					1200: {
						slidesPerView: swiperContainer.dataset.slidesPerViewDesktop,
					}
				},

				pagination: {
					el: swiperContainer.parentElement.querySelector(".featured-product-categories__swiper.swiper-pagination"),
					type: "fraction",
				},
				navigation: {
					nextEl: swiperContainer.parentElement.querySelector(".featured-product-categories__swiper.swiper-button-next"),
					prevEl: swiperContainer.parentElement.querySelector(".featured-product-categories__swiper.swiper-button-prev"),
				},
			});
		});
	}
});
